import { SvgIconModule } from '@core/modules/svgIcons.module';
import { AvatarComponent } from './avatar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [AvatarComponent],
  imports: [CommonModule, SvgIconModule],
  exports: [AvatarComponent],
})
export class AvatarModule {}
